import { Component, computed, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router, RouterModule } from '@angular/router';
import { GenerateVcodeService } from 'src/app/services/generate-vcode.service';
import { ErrorSnackbarComponent } from '../../custom/error-snackbar/error-snackbar.component';
import { ResetPasswordDataService } from 'src/app/services/reset-password-data.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';
import { NgOptimizedImage } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule
],
})
export class ForgotPasswordComponent implements OnInit {
  private analytics = inject(Analytics);
  forgotPasswordForm: FormGroup;
  isLightMode = computed(() => this.themeService.isLightMode());

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private generateVcodeService: GenerateVcodeService,
    private resetPasswordDataService: ResetPasswordDataService,
    private themeService: ThemeService
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    logEvent(this.analytics, LogEventsEnum.auth_forgot_password);
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const formValues = this.forgotPasswordForm.value;

    this.generateVcodeService
      .mutate({
        email: formValues.email,
      })
      .subscribe({
        next: () => {
          this.resetPasswordDataService.setEmail(formValues.email);
          this.router.navigate(['/verification-code']);
        },
        error: (error) => {
          console.error('Error logging in:', error.message);
          this.snackBar.openFromComponent(ErrorSnackbarComponent, {
            data: { message: 'Email was not found. Check your email' },
            duration: 3000,
          });
        },
      });
  }
}
